import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import TwoFactorNag from '../components/TwoFactorNag';
import { Box, Container } from "@mui/material";
import { useIdleTimer } from "../hooks/useIdleTimer";
import IdlePromptDialog from "../components/IdlePromptDialog.jsx"; 
import { logoutAction as logout } from "../store/auth/userSlice";
import { persistor } from "../store";
import Nav from "./components/Nav";
import PasswordExpiredModal from '../components/PasswordExpiredModal';
import { fetchProperties, fetchActiveProperty } from "../store/core/companySlice";
import PlatformSubheader from '../platform/components/PlatformSubheader';

// FIX: Importiamo il nuovo banner di sistema
import SystemAnnouncement from "../components/SystemAnnouncement"; 

export default function Layout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const isAuth = useSelector((state) => state.user.isAuth);
  const activePropertyCode = useSelector((state) => state.user.activeProperty);

  React.useEffect(() => {
    dispatch(fetchProperties());
  }, [dispatch]);

  React.useEffect(() => {
    if (activePropertyCode) {
      dispatch(fetchActiveProperty(activePropertyCode));
    }
  }, [dispatch, activePropertyCode]);

  const handleLogout = async () => {
    if (isAuth) {
      enqueueSnackbar("Sei stato disconnesso.", { variant: "info" });
      dispatch(logout());
      await persistor.purge();
      navigate('/auth/login', { replace: true });
    }
  };

  // minuti
  const IDLE_TIME = 10; 
  const PROMPT_TIME = 1; 

  const { isPromptVisible, stay } = useIdleTimer(handleLogout, IDLE_TIME, PROMPT_TIME);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <TwoFactorNag />
      
      {/* Header con Navigazione */}
      <Box 
        component="header" 
        sx={{ 
          position: 'sticky', 
          top: 0, 
          zIndex: (theme) => theme.zIndex.appBar,
          bgcolor: 'background.paper',
          boxShadow: 1,
        }}
      >
        <Container maxWidth="xl">
          <Nav />
        </Container>
        <Container maxWidth="xl">
          <PlatformSubheader />
        </Container>
      </Box>

      {/* FIX: Posizionamento strategico dell'Annuncio Globale appena sotto il menu principale */}
      <SystemAnnouncement />

      {/* Contenuto Principale */}
      <Box component="main" sx={{ flexGrow: 1, py: { xs: 2, sm: 3 } }}>
        <Container maxWidth="xl">
          <PasswordExpiredModal />
          <Outlet />
        </Container>
      </Box>

      <IdlePromptDialog
        open={isPromptVisible}
        onStay={stay}
        onLogout={handleLogout}
        countdown={PROMPT_TIME * 60}
      />
    </Box>
  );
}